import { fetchProductionRecords } from '../tools'
import type { HarnessPendingToolCall } from '../types'
import type { ClientToolExecution, ProductionHistoryToolData } from './types'

export async function executeProductionRecordsTool(
  toolCall: HarnessPendingToolCall
): Promise<ClientToolExecution> {
  const result = await fetchProductionRecords(toolCall.name, toolCall.arguments)
  const query = toolCall.arguments.query as Record<string, unknown> | undefined
  const uiData: ProductionHistoryToolData = {
    total: result.total,
    returned: result.returned,
    page: Number(query?.page || 1),
    limit: Number(query?.limit || result.returned || 1),
    note: result.note,
    records: result.records.map((record) => ({
      id: String(record.id),
      name: record.name,
      orderNo: record.order_codes,
      address: record.buyer_address || '',
      customer: record.customer_name || '',
      line: record.production_line,
      completedAt: record.create_time,
      downloadUrl: record.download_url,
    })),
  }
  return {
    toolCallId: toolCall.toolCallId,
    resultForAgent: {
      ok: true,
      data: { type: 'production-history', query, ...result },
    },
    uiData,
  }
}
